export default __webpack_public_path__ + "static/media/paid.da1032eb.svg";